import { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'
import DivisorLine from '@/components/DivisorLine'
import { Breadcrumbs, getTheme, Table, Text } from '@conexasaude/conexa-hero'
import { headersEvents, headersPatient } from './CallDetails.contants'
import useStyles from './CallDetails.styles'
import { useCallDetails } from './CallDetails.hook'

const CallDetails: FunctionComponent = () => {
  const styles = useStyles()
  const theme = getTheme()
  const {
    callDetailsList,
    getUserPatient,
    getUserProfessional,
    breadcrumbItems,
  } = useCallDetails()

  return (
    <div>
      <Breadcrumbs.Root>
        {breadcrumbItems?.map(item => {
          return (
            <Breadcrumbs.Item key={item?.title} active={item?.active}>
              {item?.path ? (
                <Link to={item.path}>{item?.title}</Link>
              ) : (
                <Text variant="link" color={theme.colors.neutral[500]}>
                  {item?.title}
                </Text>
              )}
            </Breadcrumbs.Item>
          )
        })}
      </Breadcrumbs.Root>

      <DivisorLine />
      <Text css={styles.titleWrapper} variant="headingSmall">
        Participantes
      </Text>
      <Table.Root>
        <Table.Heading>
          <Table.Row>
            {headersPatient?.map(header => (
              <Table.Head key={header}>{header}</Table.Head>
            ))}
          </Table.Row>
        </Table.Heading>
        <Table.Body>
          <Table.Row key={getUserPatient?.userId}>
            <Table.Cell>{getUserPatient?.userId}</Table.Cell>
            <Table.Cell>{getUserPatient?.name}</Table.Cell>
            <Table.Cell>{getUserPatient?.descriptionProfile}</Table.Cell>
          </Table.Row>
          <Table.Row key={getUserProfessional?.userId}>
            <Table.Cell>{getUserProfessional?.userId}</Table.Cell>
            <Table.Cell>{getUserProfessional?.name}</Table.Cell>
            <Table.Cell>{getUserProfessional?.descriptionProfile}</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table.Root>

      <Text css={styles.titleWrapper} variant="headingSmall">
        Eventos
      </Text>
      <Table.Root css={styles.tableWrapper}>
        <Table.Heading>
          <Table.Row>
            {headersEvents?.map(header => (
              <Table.Head key={header}>{header}</Table.Head>
            ))}
          </Table.Row>
        </Table.Heading>
        <Table.Body>
          {callDetailsList?.map(calls => (
            <Table.Row key={calls.callsId}>
              <Table.Cell>{calls?.hourDate}</Table.Cell>
              <Table.Cell>{calls?.eventZoom}</Table.Cell>
              <Table.Cell>{calls?.datails}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </div>
  )
}

export default CallDetails
